var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "crypto-bitcoin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.56,45.98c13.01,0 23.56,-10.38 23.56,-23.2c0,-12.81 -10.55,-23.19 -23.56,-23.19c-13.01,0 -23.56,10.38 -23.56,23.19c0,12.82 10.55,23.2 23.56,23.2z",
    fill: "#c13838",
    fillRule: "nonzero",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Serif",
    fontSize: 24,
    id: "svg_1",
    stroke: "#ffffff",
    strokeWidth: 0,
    textAnchor: "middle",
    transform: "matrix(1.55579, 0, 0, 1.53286, -12.4637, -24.9512)",
    x: 12.45,
    y: 35.95,
    xmlSpace: "preserve"
  }, "PM"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm);
export default __webpack_public_path__ + "static/media/pm.2aea86062ff981a401a971e0e603f02d.svg";
export { ForwardRef as ReactComponent };